export enum WorkflowStep {
	VetClinic,
	AddNewVet,
	OtherOwners,
	OtherNames,
	Celebration,
}
